var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStaticAud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#5694EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24976 6.49935C8.24976 6.82602 8.51226 7.08268 8.83309 7.08268H12.0939L5.74143 13.4352C5.51393 13.6627 5.51393 14.0302 5.74143 14.2577C5.96893 14.4852 6.33643 14.4852 6.56393 14.2577L12.9164 7.90518V11.166C12.9164 11.4868 13.1789 11.7493 13.4998 11.7493C13.8206 11.7493 14.0831 11.4868 14.0831 11.166V6.49935C14.0831 6.17852 13.8206 5.91602 13.4998 5.91602H8.83309C8.51226 5.91602 8.24976 6.17852 8.24976 6.49935Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticAud);
export default __webpack_public_path__ + "static/media/static_aud.6118ca3c1fbdf535559d82775fcf06c8.svg";
export { ForwardRef as ReactComponent };